










import { Vue, Component } from 'vue-property-decorator';
import ClientesProveedores from '@/pantallas/ClienteProveedor/ClientesProveedores.vue';

@Component({
  components: { ClientesProveedores },
})
export default class ClientesProveedoresPantalla extends Vue {}
